import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Stack,
  Paper,
  Grid
} from '@mui/material';

const Filters = ({ filters, setFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleApplyFilters = () => {
    setFilters(localFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      user_name: '',
      user_email: '',
      createdAt: ''
    };
    setLocalFilters(clearedFilters);
    setFilters(clearedFilters);
  };

  return (
    <Paper elevation={3} sx={{ 
      p: 3, 
      mb: 4,
      borderRadius: 3,
      background: 'linear-gradient(to right, #ffffff, #f8f9fa)',
      boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
      border: '1px solid rgba(0,0,0,0.05)'
    }}>
      <Grid container spacing={3} alignItems="flex-end">
        <Grid item xs={12} sm={4}>
          <TextField
            label="Search by Name"
            name="user_name"
            variant="outlined"
            value={localFilters.user_name || ''}
            onChange={handleInputChange}
            fullWidth
            InputProps={{
              sx: {
                borderRadius: 2,
                backgroundColor: 'white',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#1976d2'
                }
              }
            }}
            InputLabelProps={{
              sx: {
                color: 'text.secondary',
                fontWeight: 500
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Search by Email"
            name="user_email"
            variant="outlined"
            value={localFilters.user_email || ''}
            onChange={handleInputChange}
            fullWidth
            InputProps={{
              sx: {
                borderRadius: 2,
                backgroundColor: 'white',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#1976d2'
                }
              }
            }}
            InputLabelProps={{
              sx: {
                color: 'text.secondary',
                fontWeight: 500
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Creation Date"
            name="createdAt"
            type="date"
            variant="outlined"
            value={localFilters.createdAt || ''}
            onChange={handleInputChange}
            InputLabelProps={{ 
              shrink: true,
              sx: {
                color: 'text.secondary',
                fontWeight: 500
              }
            }}
            fullWidth
            InputProps={{
              sx: {
                borderRadius: 2,
                backgroundColor: 'white',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#1976d2'
                }
              }
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 1 }}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleApplyFilters}
              sx={{
                px: 4,
                py: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 2px 6px rgba(25, 118, 210, 0.2)',
                '&:hover': {
                  boxShadow: '0 4px 10px rgba(25, 118, 210, 0.3)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Apply Filters
            </Button>
            <Button 
              variant="outlined" 
              color="secondary" 
              onClick={handleClearFilters}
              sx={{
                px: 4,
                py: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                borderWidth: 2,
                '&:hover': {
                  borderWidth: 2
                }
              }}
            >
              Clear All
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Filters;